import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './App.scss';
import qs from "qs";
import App from './App';
import GlobalResilienceMap from "./components/global-resilience-map/GlobalResilienceMap";
import GlobalResilienceIndex from "./components/global-resilience-index/GlobalResilienceIndex";
import CountryScorecard from "./components/country-scorecard/CountryScorecard";
import Compare from "./components/compare/Compare";

function getEl(embedSelector) {
    if (typeof embedSelector === "string") {
        const el = document.querySelector(embedSelector);
        // if (!el) throw new Error(`No div matching selector "${embedSelector}"`);
        if (!el) return;
        return el;
    } else {
        return embedSelector;
    }
}

// function getEls(embedSelector) {
//     if (typeof embedSelector === "string") {
//         const els = document.querySelectorAll(embedSelector);
//         // if (!els) throw new Error(`No divs matching selector "${embedSelector}"`);
//         if (!els) return;
//         return els;
//     } else {
//         return embedSelector;
//     }
// }

function getUrlParams() {
    const params = qs.parse(window.location.search.slice(1));

    return {
        type: params.embed,
        city: params.city,
    };
}

window.addEventListener("DOMContentLoaded", () => {
    const params = getUrlParams();
    let hasEmbeds = false;

    // Global Resilience Map component
    if (getEl("[data-global-resilience-map]")) {
        const container = getEl("[data-global-resilience-map]");
        const root = createRoot(container);
        root.render(<GlobalResilienceMap {...params} />);
        hasEmbeds = true;
    }

    // Global Resilience Index component
    if (getEl("[data-global-resilience-index]")) {
        const container = getEl("[data-global-resilience-index]");
        const root = createRoot(container);
        root.render(<GlobalResilienceIndex {...params} />);
        hasEmbeds = true;
    }

    // Country Scorecard component
    if (getEl("[data-resilience-country-scoreboards]")) {
        const container = getEl("[data-resilience-country-scoreboards]");
        const root = createRoot(container);
        root.render(<CountryScorecard {...params} />);
        hasEmbeds = true;
    }

    // Compare component
    if (getEl("[data-resilience-compare]")) {
        const container = getEl("[data-resilience-compare]");
        const baseUrl = container.getAttribute('data-base-url') || '';
        const root = createRoot(container);
        root.render(<Compare {...params} baseUrl={baseUrl} />);
        hasEmbeds = true;
    }

    // If no embed divs found, render App.js for development preview
    if (!hasEmbeds) {
        const rootElement = document.getElementById('root');
        if (rootElement) {
            const root = createRoot(rootElement);
            root.render(<App />);
        }
    }
});


